module.exports = __webpack_public_path__ + "img/20191209165016881.b4aac8d5.jpg";